"use client";
import { create } from 'zustand';
import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

interface RouterState {
  pathname: string;
  searchParams: URLSearchParams | null; // 👈 保留原始对象或序列化
  // 也可以加：search: string（即 ? 后的字符串）

  router: AppRouterInstance | null;
  setRouter: (router: AppRouterInstance) => void;

  push: (url: string) => void;
  replace: (url: string) => void;
  back: () => void;
  refresh: () => void;

  // 更新完整路由信息
  _updateRoute: (pathname: string, searchParams: URLSearchParams) => void;
}

export const useAppRouter = create<RouterState>((set, get) => ({
  pathname: typeof window !== 'undefined' ? window.location.pathname : '/',
  searchParams: typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search)
    : null,

  router: null,
  setRouter: (router) => set({ router }),

  push: (url) => get().router?.push(url),
  replace: (url) => get().router?.replace(url),
  back: () => get().router?.back(),
  refresh: () => get().router?.refresh(),

  _updateRoute: (pathname, searchParams) => {
    set({ pathname, searchParams });
  },
}));

